<script>
  export let align;
  export let visible = true;

  $: hidden = !visible;
  $: prev = align === "left";
  $: next = align === "right";
</script>

<style>
  .navigation-button {
    --size: 2.3rem;
    --icon-fill: #fff;

    position: absolute;
    top: var(--slides-action-top);
    transform: translateY(-50%);
    z-index: 1;
    border: 0;
    padding: 0.5rem;
    background: #333;
    box-sizing: border-box;
    width: var(--size);
    height: var(--size);
    overflow: hidden;
    border-radius: 50%;
    box-shadow: 0 1px 0px 0px rgba(0, 0, 0, 0.59);
    border: 2px solid #fff;
    border-color: var(--tv-background-color, #fff);
    transition: ease-out 100ms all;
    cursor: pointer;
  }

  .navigation-button:hover {
    --icon-fill: #eee;
    --size: 2.5rem;
    box-shadow: 0 1.5px 1px 0px rgba(0, 0, 0, 0.59);
  }

  .navigation-button:focus {
    --icon-fill: #fff;
    --size: 2.5rem;
    box-shadow: 0 1px 0px 0px rgba(0, 0, 0, 0.59),
      inset 0 1px 2px rgb(27 31 35 / 8%), 0 0 0 0.2em rgb(3 102 214 / 30%);
    outline: 0;
  }

  .navigation-button:active {
    --icon-fill: #fff;
    --size: 2.3rem;
    background: #222;
  }

  .prev {
    left: 0;
    transform: translate(-50%, -50%);
  }
  .next {
    right: 0;
    transform: translate(50%, -50%);
  }
  .hidden {
    display: block;
    opacity: 0;
    cursor: default;
    visibility: visible;
  }
</style>

<button
  on:click
  disabled={hidden}
  class:prev
  class:next
  class:hidden
  class="navigation-button">
  <slot />
</button>
